import React, { useState, useEffect, useRef } from "react"
import { useLocation } from "@gatsbyjs/reach-router"
import { createPortal } from "react-dom"
import { Link } from "gatsby"

const NAV_LINKS = [
    { label: "Home", to: "/" },
    { label: "About Us", to: "/about" },
    { label: "Our Services", to: "/services" },
    { label: "Our Work", to: "/projects" },
    { label: "Contact", to: "/contact" },
]
 
export default function Menu() {
    const closeMenu = () => {
        document.body.classList.remove('menu-open')
    }
    return (
    <>
        <div  className='menu--panel p20 flex flex-col gap-60'>
            <div className='menu-top inner flex space-between align-center'>
                <a href='/' className='link logo' aria-label='Iron Workers'></a>
                <button type='button' className='button' onClick={closeMenu}>
                    <span className='button-icon menu-icon' aria-hidden='true'/>
                    Close
                </button>
            </div>
            <nav className='flex inner gap-60 space-between m-flex-col m-gap-10 mta m-mba white'>
                {NAV_LINKS.map((link, i) => (
                    <Link key={link.to} to={link.to} className='menu-link h1' activeClassName='menu-link-active'>{link.label}</Link>
                ))}
            </nav>
        </div>
        <div className='menu--underlay' onClick={closeMenu}/>
    </>
    )
}

